let firstlogin = false;

function mobileSwitch() {
  let leftElement = document.querySelector(".left-tab.tab");
  let rightElement = document.querySelector(".right-content-container");
  if (leftElement) {
    leftElement.style.display = "none";
  }
  if (rightElement) {
    rightElement.style.display = "block";
  }
}

function leftdisplayAccount() {
  let leftElement = document.querySelector(".left-tab.tab");
  let rightElement = document.querySelector(".right-content-container");

  if (leftElement) {
    leftElement.style.display = "block";
  }

  if (rightElement) {
    rightElement.style.display = "none";
  }

  // Remove the hash from the URL without reloading the page
  if (window.location.hash) {
    history.replaceState(null, null, window.location.pathname);
  }
}

function openAccountTab(evt, tabName) {
  if (window.innerWidth <= 1024) {
    if (window.location.href.includes("account#") || window.location.href.includes("orders")) {
      mobileSwitch();
    }
    if (firstlogin) {
      mobileSwitch();
    } else {
      firstlogin = true;
    }
  }
  if (evt) evt.preventDefault();

  // Check if this is the wishlist tab
  if (tabName === "wishlist") {
    window.location.href = "/pages/swym-wishlist";
    return;
  }

  // Hide all tab contents
  var tabcontent = document.getElementsByClassName("tabcontent");
  for (var i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Remove active class from all tab links
  var tablinks = document.getElementsByClassName("tablinks");
  for (var i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show selected tab
  var selectedTab = document.getElementById(tabName);
  if (selectedTab) {
    selectedTab.style.display = "block";
  }

  // Add active class to the clicked tab link
  if (evt && evt.currentTarget) {
    evt.currentTarget.className += " active";
  }

  // Update the URL hash (except for wishlist)
  if (tabName !== "wishlist") {
    window.location.hash = tabName;
  }
}

function URL_tab() {
  const hash = window.location.hash.replace("#", "");
  if (hash) {
    let tabLinks = document.querySelectorAll(".tablinks");
    let found = false;

    tabLinks.forEach((tabLink) => {
      let linkTabName = tabLink.getAttribute("href").replace("#", "");
      if (linkTabName === hash) {
        // Skip wishlist tab in URL handling
        if (linkTabName !== "wishlist") {
          tabLink.click();
          found = true;
        }
      }
    });

    if (!found && hash !== "wishlist") {
      window.location.href = "/account";
    }
  } else {
    // Default to profile tab
    let defaultTab = document.getElementById("defaultOpen");
    if (defaultTab && !defaultTab.classList.contains("active")) {
      defaultTab.click();
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  let tabcontents = document.querySelectorAll(".tabcontent");
  tabcontents.forEach((tab) => {
    tab.style.display = "none";
  });

  // Preloader Script
  const preloader = document.querySelector(".account_preloader");
  if (preloader) {
    preloader.style.display = "none";
  }

  URL_tab();
});
